<div class="doc-preview">
  <div class="doc-preview__header">
    <div class="doc-preview__title">
      <mat-icon class="doc-preview__icon">description</mat-icon>
      <div class="doc-preview__title-text">
        <div class="doc-preview__name" [title]="documentName">{{ documentName }}</div>
        <div class="doc-preview__context" *ngIf="contextLabel">{{ contextLabel }}</div>
      </div>
    </div>

    <!-- PDF-only: search + match counter + nav -->
    <div class="doc-preview__search" *ngIf="isPdf()">
      <div class="doc-preview__search-input-wrap">
        <mat-icon class="search-icon">search</mat-icon>
        <input type="text"
               class="doc-preview__search-input"
               placeholder="Find in document..."
               [(ngModel)]="searchText"
               (ngModelChange)="onSearchTextChange()">
        <button class="doc-preview__search-clear"
                type="button"
                *ngIf="searchText"
                (click)="clearSearch()"
                matTooltip="Clear">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <span class="doc-preview__match-count"
            [class.no-matches]="!isSearching && searchText && pdfLoaded && matchCount === 0"
            [class.searching]="isSearching">
        <!-- Empty box -->
        <ng-container *ngIf="!searchText">Search the document</ng-container>

        <!-- Live progress while PDF.js scans pages -->
        <ng-container *ngIf="searchText && isSearching">
          <mat-progress-spinner mode="indeterminate"
                                diameter="14"
                                strokeWidth="2"
                                class="searching-spinner">
          </mat-progress-spinner>
          <span class="searching-text">
            Searching<ng-container *ngIf="matchCount > 0">&nbsp;&middot; {{ matchCount }} so far</ng-container>
          </span>
        </ng-container>

        <!-- Final result: found N -->
        <ng-container *ngIf="searchText && !isSearching && matchCount > 0">
          <strong>{{ currentMatchIndex || 1 }}</strong> of {{ matchCount }}
        </ng-container>

        <!-- Final result: nothing found -->
        <ng-container *ngIf="searchText && !isSearching && pdfLoaded && matchCount === 0">
          No matches
        </ng-container>
      </span>
      <div class="doc-preview__match-nav"
           [class.is-active]="matchCount > 0">
        <button type="button"
                class="doc-preview__match-btn"
                matTooltip="Previous match (Shift+Enter)"
                [disabled]="matchCount === 0"
                (click)="prevMatch()">
          <mat-icon>arrow_upward</mat-icon>
        </button>
        <span class="doc-preview__match-nav-sep"></span>
        <button type="button"
                class="doc-preview__match-btn"
                matTooltip="Next match (Enter)"
                [disabled]="matchCount === 0"
                (click)="nextMatch()">
          <mat-icon>arrow_downward</mat-icon>
        </button>
      </div>
    </div>

    <div class="doc-preview__actions">
      <span class="doc-preview__page" *ngIf="isPdf() && pdfLoaded">
        Page <strong>{{ currentPage }}</strong> of {{ pdfTotalPages }}
      </span>
      <button mat-icon-button matTooltip="Open in new tab" (click)="openInNewTab()">
        <mat-icon>open_in_new</mat-icon>
      </button>
      <button mat-icon-button matTooltip="Download" (click)="download()">
        <mat-icon>cloud_download</mat-icon>
      </button>
      <button mat-icon-button matTooltip="Close" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="doc-preview__body">
    <!-- PDF: ng2-pdf-viewer with PDF.js find controller for search highlight -->
    <pdf-viewer
      *ngIf="isPdf()"
      class="doc-preview__pdf"
      [src]="documentpath"
      [render-text]="true"
      [show-all]="true"
      [original-size]="false"
      [autoresize]="true"
      [fit-to-page]="false"
      [zoom-scale]="'page-width'"
      (after-load-complete)="onPdfLoaded($event)"
      (text-layer-rendered)="onTextLayerRendered($event)"
      (page-rendered)="onPdfPageChange($event.pageNumber)"
      (pages-initialized)="onPdfPageChange(1)"
      (update-find-matches-count)="onFindMatch($event)"
      (update-find-state)="onFindMatch($event)">
    </pdf-viewer>

    <!-- Office docs via Google viewer -->
    <ngx-doc-viewer
      *ngIf="isOfficeDoc()"
      [url]="documentpath"
      viewer="google"
      width="100%"
      height="100%">
    </ngx-doc-viewer>

    <!-- Image preview -->
    <div class="doc-preview__image-wrap" *ngIf="isImage()">
      <img [src]="documentpath" [alt]="documentName" />
    </div>

    <!-- Unrecognised type: graceful fallback -->
    <div class="doc-preview__fallback"
         *ngIf="!isPdf() && !isOfficeDoc() && !isImage()">
      <mat-icon>insert_drive_file</mat-icon>
      <p>Preview is not available for this file type ({{ documentType || 'unknown' }}).</p>
      <button mat-flat-button color="primary" (click)="openInNewTab()">
        <mat-icon>open_in_new</mat-icon> Open in new tab
      </button>
    </div>
  </div>
</div>
